/* Fable & Mirth — v2 motion layer (vanilla, no dependencies) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(pointer: fine)').matches;
  const desk = () => window.innerWidth >= 990;
  const root = document.documentElement;
  if (!reduce) root.classList.add('fm-motion');

  /* ---------- Text splitting ---------- */
  function splitWords(el) {
    if (el.dataset.fmDone) return;
    el.dataset.fmDone = '1';
    let i = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((w) => {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
            const o = document.createElement('span'); o.className = 'fm-sw';
            const s = document.createElement('span'); s.textContent = w; s.style.setProperty('--i', i++);
            o.appendChild(s); frag.appendChild(o);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && !n.classList.contains('fm-statement__pic')) walk(n);
      });
    };
    walk(el);
  }
  function splitHighlight(el) {
    if (el.dataset.fmDone) return;
    el.dataset.fmDone = '1';
    const walk = (node) => {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((w) => {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
            const s = document.createElement('span'); s.className = 'fm-w'; s.textContent = w; frag.appendChild(s);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && !n.classList.contains('fm-statement__pic')) walk(n);
        else if (n.nodeType === 1) n.classList.add('fm-w');
      });
    };
    walk(el);
  }
  function splitLetters(el) {
    if (el.dataset.fmDone) return;
    el.dataset.fmDone = '1';
    let i = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          [...n.textContent].forEach((c) => {
            const s = document.createElement('span'); s.className = 'fm-ch'; s.textContent = c === ' ' ? ' ' : c; s.style.setProperty('--i', i++); frag.appendChild(s);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(el);
  }

  /* ---------- Reveal on scroll ---------- */
  let io;
  function initReveal(scope = document) {
    if (reduce) { $$('[data-fm-reveal],[data-fm-split],[data-fm-letters]', scope).forEach((e) => e.classList.add('is-in')); return; }
    $$('[data-fm-split]', scope).forEach(splitWords);
    $$('[data-fm-letters]', scope).forEach(splitLetters);
    io = io || new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    $$('[data-fm-reveal],[data-fm-split],[data-fm-letters]', scope).forEach((el) => { if (!el.classList.contains('is-in')) io.observe(el); });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    const hdr = $('[data-fm-hdr]');
    if (!hdr) return;
    const wrap = hdr.closest('.fm-section-header') || hdr.parentElement;
    const overlay = () => hdr.classList.contains('fm-hdr--overlay');
    const sticky = hdr.dataset.sticky === 'true';
    if (wrap) {
      wrap.classList.toggle('fm-is-sticky', sticky);
      wrap.classList.toggle('fm-is-overlay', overlay());
    }
    const setH = () => root.style.setProperty('--fm-hdr-h', overlay() ? '0px' : (wrap ? wrap.offsetHeight : hdr.offsetHeight) + 'px');
    setH();
    window.addEventListener('resize', setH);
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (wrap) wrap.classList.toggle('fm-is-overlay', overlay());
      hdr.classList.toggle('is-solid', !overlay() || (sticky && y > 40));
      hdr.classList.toggle('is-compact', sticky && y > 40);
      if (sticky) {
        const open = hdr.querySelector('.fm-hdr__item.is-open') || hdr.classList.contains('is-menu');
        hdr.classList.toggle('is-hidden', !open && y > 500 && y > last + 2);
        if (y < last - 2) hdr.classList.remove('is-hidden');
      }
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('fm:header', () => { setH(); onScroll(); });
    onScroll();

    $$('.fm-hdr__item[data-fm-mega2]', hdr).forEach((item) => {
      const btn = item.querySelector('.fm-hdr__link');
      let t;
      const open = () => {
        $$('.fm-hdr__item.is-open', hdr).forEach((o) => o !== item && close(o));
        item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); hdr.classList.add('is-menu');
      };
      const close = (el = item) => {
        el.classList.remove('is-open'); el.querySelector('.fm-hdr__link').setAttribute('aria-expanded', 'false');
        if (!hdr.querySelector('.fm-hdr__item.is-open')) hdr.classList.remove('is-menu');
      };
      item.addEventListener('mouseenter', () => { if (!desk()) return; clearTimeout(t); t = setTimeout(open, 80); });
      item.addEventListener('mouseleave', () => { clearTimeout(t); t = setTimeout(() => close(), 180); });
      btn.addEventListener('click', () => (item.classList.contains('is-open') ? close() : open()));
      item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); btn.focus(); } });
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
      // image stage swap
      const stage = item.querySelector('.fm-mega2__stage');
      $$('[data-stage]', item).forEach((a) => {
        const swap = () => {
          if (!stage) return;
          $$('[data-stage]', item).forEach((x) => x.classList.toggle('is-active', x === a));
          $$(':scope > *', stage).forEach((s, i) => s.classList.toggle('is-active', String(i) === a.dataset.stage));
        };
        a.addEventListener('mouseenter', swap); a.addEventListener('focus', swap);
      });
    });

    // full-screen menu
    const menu = $('[data-fm-menu]');
    if (menu) {
      $$('.fm-menu__list > li', menu).forEach((li, i) => li.style.setProperty('--i', i));
      let opener;
      const open = (e) => { opener = e.currentTarget; menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); root.style.overflow = 'hidden'; setTimeout(() => menu.querySelector('[data-fm-menu-close]')?.focus(), 60); };
      const close = () => { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); root.style.overflow = ''; opener?.focus(); };
      $$('[data-fm-menu-open]').forEach((b) => b.addEventListener('click', open));
      $$('[data-fm-menu-close]', menu).forEach((b) => b.addEventListener('click', close));
      menu.addEventListener('keydown', (e) => e.key === 'Escape' && close());
      menu.addEventListener('click', (e) => { if (e.target.closest('a')) close(); });
    }
  }

  /* ---------- Slideshow ---------- */
  function initShow(scope = document) {
    $$('[data-fm-show]', scope).forEach((show) => {
      const slides = $$('.fm-show__slide', show);
      const bars = $$('.fm-show__bars button', show);
      const cur = $('[data-fm-show-cur]', show);
      const dur = Number(show.dataset.interval) || 7000;
      show.style.setProperty('--dur', dur + 'ms');
      let i = 0, t;
      $$('.fm-show__title', show).forEach((h) => h.setAttribute('data-fm-split', ''));
      if (!reduce) $$('.fm-show__title', show).forEach(splitWords);
      const go = (n) => {
        slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true');
        const title = slides[i].querySelector('.fm-show__title'); title && title.classList.remove('is-in');
        bars.forEach((b, k) => { b.classList.remove('is-active'); b.classList.toggle('is-done', k < n); });
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); slides[i].removeAttribute('aria-hidden');
        // restart animations
        const m = slides[i].querySelector('.fm-show__media > *'); if (m) { m.style.animation = 'none'; void m.offsetWidth; m.style.animation = ''; }
        const nt = slides[i].querySelector('.fm-show__title'); if (nt) setTimeout(() => nt.classList.add('is-in'), 250);
        if (bars[i]) { void bars[i].offsetWidth; bars[i].classList.add('is-active'); }
        if (cur) cur.textContent = String(i + 1).padStart(2, '0');
      };
      const play = () => { clearInterval(t); if (reduce || slides.length < 2) return; t = setInterval(() => go(i + 1), dur); };
      bars.forEach((b, k) => b.addEventListener('click', () => { go(k); play(); }));
      $$('[data-fm-show-prev]', show).forEach((b) => b.addEventListener('click', () => { go(i - 1); play(); }));
      $$('[data-fm-show-next]', show).forEach((b) => b.addEventListener('click', () => { go(i + 1); play(); }));
      document.addEventListener('visibilitychange', () => (document.hidden ? clearInterval(t) : play()));
      setTimeout(() => { slides[0]?.querySelector('.fm-show__title')?.classList.add('is-in'); bars[0]?.classList.add('is-active'); }, document.querySelector('.fm-loader') ? 1300 : 200);
      play();
    });
  }

  /* ---------- Quotes carousel ---------- */
  function initQuotes(scope = document) {
    $$('[data-fm-quotes]', scope).forEach((q) => {
      const items = $$('.fm-quotes__q', q), tabs = $$('.fm-quotes__tabs button', q);
      let i = 0, t;
      const go = (n) => {
        i = (n + items.length) % items.length;
        items.forEach((x, k) => x.classList.toggle('is-active', k === i));
        tabs.forEach((x, k) => { x.setAttribute('aria-selected', String(k === i)); if (k === i) { x.style.animation = 'none'; void x.offsetWidth; x.style.animation = ''; } });
      };
      const play = () => { clearInterval(t); if (!reduce) t = setInterval(() => go(i + 1), 6000); };
      tabs.forEach((b, k) => b.addEventListener('click', () => { go(k); play(); }));
      go(0); play();
    });
  }

  /* ---------- Scroll-driven effects (one rAF loop) ---------- */
  const marquees = [], parallax = [], hls = [], hss = [];
  let vel = 0, lastY = window.scrollY;
  function collect(scope = document) {
    $$('[data-fm-marquee]', scope).forEach((m) => {
      const track = m.querySelector('.fm-marquee__track');
      if (!track || track.dataset.fmDone) return; track.dataset.fmDone = '1';
      track.innerHTML += track.innerHTML; // duplicate for loop
      marquees.push({ track, x: 0, dir: Number(m.dataset.dir || -1), speed: Number(m.dataset.speed || 0.6) });
    });
    $$('[data-fm-parallax]', scope).forEach((el) => parallax.push({ el, k: Number(el.dataset.fmParallax) || 0.12 }));
    $$('[data-fm-highlight]', scope).forEach((el) => { splitHighlight(el); hls.push({ el, words: $$('.fm-w', el) }); });
    $$('[data-fm-hscroll]', scope).forEach((el) => hss.push({ el, sticky: el.querySelector('.fm-hs__sticky'), track: el.querySelector('.fm-hs__track'), bar: el.querySelector('.fm-hs__progress span') }));
  }
  function layoutHS() {
    hss.forEach((h) => {
      const pin = desk() && !reduce;
      h.el.classList.toggle('is-pinned', pin);
      if (pin) {
        const dist = Math.max(0, h.track.scrollWidth - window.innerWidth);
        h.dist = dist;
        h.el.style.height = (window.innerHeight + dist) + 'px';
      } else { h.el.style.height = ''; h.track.style.transform = ''; h.dist = 0; }
    });
  }
  function frame() {
    const y = window.scrollY, vh = window.innerHeight;
    vel += ((y - lastY) - vel) * 0.1; lastY = y;
    marquees.forEach((m) => {
      if (reduce) return;
      if (Math.abs(vel) > 0.5) m.dir = vel > 0 ? -1 : 1;
      m.x += m.dir * (m.speed + Math.min(Math.abs(vel) * 0.25, 8));
      const half = m.track.scrollWidth / 2;
      if (m.x <= -half) m.x += half; if (m.x > 0) m.x -= half;
      m.track.style.transform = `translate3d(${m.x}px,0,0)`;
    });
    if (!reduce) parallax.forEach(({ el, k }) => {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      const c = (r.top + r.height / 2 - vh / 2);
      el.style.transform = `translate3d(0,${(-c * k).toFixed(1)}px,0)`;
    });
    hls.forEach(({ el, words }) => {
      if (reduce) return;
      const r = el.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      const n = Math.round(p * words.length);
      words.forEach((w, k) => w.classList.toggle('is-lit', k < n));
    });
    hss.forEach((h) => {
      let p;
      if (h.el.classList.contains('is-pinned')) {
        const r = h.el.getBoundingClientRect();
        p = Math.min(1, Math.max(0, -r.top / (h.dist || 1)));
        h.track.style.transform = `translate3d(${(-p * h.dist).toFixed(1)}px,0,0)`;
      } else {
        const t = h.track; p = t.scrollLeft / Math.max(1, t.scrollWidth - t.clientWidth);
      }
      if (h.bar) h.bar.style.setProperty('--p', p.toFixed(3));
    });
    requestAnimationFrame(frame);
  }

  /* ---------- Category list floating image ---------- */
  function initCatList(scope = document) {
    $$('[data-fm-catlist]', scope).forEach((list) => {
      const fl = list.querySelector('.fm-catlist__float');
      if (!fl || !fine) return;
      const imgs = $$(':scope > *', fl);
      let x = 0, y = 0, cx = 0, cy = 0, on = false, raf;
      const loop = () => {
        cx += (x - cx) * 0.14; cy += (y - cy) * 0.14;
        const rot = Math.max(-10, Math.min(10, (x - cx) * 0.08));
        fl.style.transform = `translate3d(${cx}px,${cy}px,0) translate(-50%,-50%) rotate(${rot}deg)`;
        if (on) raf = requestAnimationFrame(loop);
      };
      $$('.fm-catlist__row a', list).forEach((a, k) => {
        a.addEventListener('mouseenter', (e) => {
          imgs.forEach((im, j) => im.classList.toggle('is-active', j === k));
          if (!on) { cx = x = e.clientX; cy = y = e.clientY; on = true; fl.classList.add('is-on'); raf = requestAnimationFrame(loop); }
        });
      });
      list.addEventListener('mousemove', (e) => { x = e.clientX; y = e.clientY; });
      list.querySelector('.fm-catlist__list').addEventListener('mouseleave', () => { on = false; fl.classList.remove('is-on'); cancelAnimationFrame(raf); });
    });
  }

  /* ---------- Cursor + magnetic ---------- */
  function initCursor() {
    if (!fine || reduce) return;
    const c = document.createElement('div'); c.className = 'fm-cursor'; c.setAttribute('aria-hidden', 'true'); c.innerHTML = '<span></span>';
    document.body.appendChild(c);
    let x = -100, y = -100, cx = x, cy = y;
    window.addEventListener('mousemove', (e) => { x = e.clientX; y = e.clientY; c.classList.add('is-on'); }, { passive: true });
    document.addEventListener('mouseleave', () => c.classList.remove('is-on'));
    const loop = () => { cx += (x - cx) * 0.22; cy += (y - cy) * 0.22; c.style.transform = `translate3d(${cx}px,${cy}px,0)`; requestAnimationFrame(loop); };
    loop();
    document.addEventListener('mouseover', (e) => {
      const big = e.target.closest('[data-cursor]');
      const link = e.target.closest('a, button');
      c.classList.toggle('is-big', !!big);
      c.querySelector('span').textContent = big ? big.dataset.cursor : '';
      c.classList.toggle('is-link', !big && !!link);
    });
    $$('[data-fm-magnetic]').forEach((b) => {
      b.addEventListener('mousemove', (e) => { const r = b.getBoundingClientRect(); b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.25}px,${(e.clientY - r.top - r.height / 2) * 0.35}px)`; });
      b.addEventListener('mouseleave', () => (b.style.transform = ''));
    });
  }

  function init(scope = document) {
    initReveal(scope); initShow(scope); initQuotes(scope); collect(scope); initCatList(scope);
  }
  function boot() {
    const ld = $('.fm-loader');
    if (ld) { if (reduce) ld.remove(); else setTimeout(() => ld.remove(), 2200); }
    initHeader(); init(); initCursor(); layoutHS();
    window.addEventListener('resize', layoutHS);
    window.addEventListener('load', layoutHS);
    requestAnimationFrame(frame);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', (e) => { init(e.target); layoutHS(); });
  window.FMMotion = { refresh: () => { layoutHS(); initReveal(); } };
})();
